<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="5" :sm="24">
            <a-form-item label="购销全流程">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-model="queryParam.project_id"
                placeholder="请输入名称"
                :default-active-first-option="false"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="4" :sm="24" v-if="true">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1500 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="money_render" slot-scope="text">
        {{ text | numberFormat }}
      </div>
      <span slot="approval_needed" slot-scope="text, record">
        <a-popconfirm
          title="确定开启审批吗?"
          :disabled="text"
          @confirm="() => approvalNeeded(record, undefined, false)">
          <a-switch checked-children="是" un-checked-children="否" :checked="record.is_approval_needed" :disabled="record.is_approval_needed"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleClient(record)">附件</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a @click="handleEdit(record)" v-if="isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"
            title="确定重启审批?"
            @confirm="() => approvalNeeded(record, 'settlement', true)">
            <span>重启审批</span>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'
import { settlement_create, settlement_delete, settlement_list, settlement_update } from '@/api/trade_settlement'
import { project_list } from '@/api/trade_project'
import debounce from 'lodash/debounce'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      mdl: {
        empty: true,
        name: ''
      },
      projectList: [],
      // 查询参数
      queryParam: {
        project_id: undefined
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '系统编号',
          dataIndex: 'number',
          width: 200,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '购销全流程',
          dataIndex: 'project',
          width: 150,
          ellipsis: true
        },
        {
          title: '购销合同编号',
          dataIndex: 'contract_number',
          width: 150,
          ellipsis: true
        },
        {
          title: '结算数量依据',
          dataIndex: 'settlement_quantity_basis',
          width: 200,
          ellipsis: true
        },
        {
          title: '结算数量',
          dataIndex: 'settlement_quantity',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'money_render' }
        },
        {
          title: '结算单位',
          dataIndex: 'settlement_unit',
          width: 200,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.unit[text] || '无'
        },
        {
          title: '是否存在扣减项',
          dataIndex: 'has_deduction_item',
          width: 150,
          ellipsis: true,
          customRender: (text) => text ? '是' : '否'
        },
        {
          title: '扣减数量',
          dataIndex: 'deduction_quantity',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'money_render' }
        },
        {
          title: '单位',
          dataIndex: 'unit',
          width: 160,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.unit[text] || '无'
        },
        {
          title: '最终结算数量',
          dataIndex: 'final_settlement_quantity',
          width: 160,
          ellipsis: true
        },
        {
          title: '结算质量依据',
          dataIndex: 'settlement_quality_basis',
          width: 160,
          ellipsis: true
        },
        {
          title: '结算质量',
          dataIndex: 'settlement_quality',
          width: 160,
          ellipsis: true
        },
        {
          title: '是否存在质量扣款',
          dataIndex: 'has_quality_deduction',
          width: 150,
          ellipsis: true,
          customRender: (text) => text ? '是' : '否'
        },
        {
          title: '扣款总金额',
          dataIndex: 'total_deduction_amount',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'money_render' }
        },
        {
          title: '扣款币种',
          dataIndex: 'currency',
          width: 160,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.currency[text] || '无'
        },
        {
          title: '结算币种',
          dataIndex: 'settlement_pricing_currency',
          width: 160,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.currency[text] || '无'
        },
        {
          title: '结算单价',
          dataIndex: 'settlement_unit_price',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'money_render' }
        },
        {
          title: '结算金额',
          dataIndex: 'settlement_amount',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'money_render' }
        },
        {
          title: '结算汇率',
          dataIndex: 'settlement_exchange_rate',
          width: 160,
          ellipsis: true
        },
        {
          title: '开启审批',
          dataIndex: 'is_approval_needed',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'approval_needed' }
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text, record) => record.is_approval_needed ? this.$Dictionaries.approval_result[text] : '未开启审批'
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '时间',
          dataIndex: 'create_time',
          width: 180
        },
        {

          title: '操作',
          dataIndex: 'action',
          width: '200px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return settlement_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            this.mdl.empty = !(res.data.entries.length > 0)
            return res.data
          })
      }
    }
  },
  created () {
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    handleProjectSearch (value) {
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      // const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      // const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      this.mdl = { number: year + '' + month + '' + day + '' + hours }
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          if (data.attachment) {
            data.attachment = data.attachment.map(item => {
              item.key = undefined
              return item
            })
          }

          if (data.product_parameters) {
            data.product_parameters = data.product_parameters.map(item => {
              item.key = undefined
              return item
            })
          }
          values = { ...values, ...data }
          // 新增
          settlement_create(values).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.visible = false
              // 重置表单数据
              form.resetFields()
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleEdit (record) {
      this.$router.push({ path: '/trade/settlement/' + record.id })
    },
    handleClient (record) {
      this.$router.push({ path: '/trade/settlement/' + record.id + '/attachment', query: { record: record.name } })
    },
    approvalNeeded (record, type, approval_again) {
      const is_approval_needed = approval_again ? true : !record.is_approval_needed
      if (is_approval_needed) {
        this.loading = true
        settlement_update({ is_approval_needed: is_approval_needed }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleDelete (record) {
      settlement_delete(record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    }
  }
}
</script>
